import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { StatsBar } from '../components/StatsBar';
import { ValueProps } from '../components/ValueProps';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white selection:bg-slate-600 selection:text-white pt-20" data-id="element-250">
      <Header data-id="element-251" />
      <Hero data-id="element-252" />
      <StatsBar data-id="element-253" />
      <ValueProps data-id="element-254" />
      <ContactForm data-id="element-255" />
      <Footer data-id="element-256" />
    </main>;
}